import React from 'react';
import { withTranslation } from 'react-i18next';
import { toUpper } from 'lodash';
import { withRouter } from 'react-router-dom/cjs/react-router-dom.min';
import { connect } from 'react-redux';
import { useSnackbar } from 'notistack';
import { formatDate } from '../../helper';
import { formatNumberDecimal } from '../../helper';

const formatTxHash = (hash) => {
    if (!hash) return '';
    if (hash.length <= 12) return hash;
    return `${hash.slice(0, 8)}...${hash.slice(-5)}`;
};

const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
        // You can add a toast notification here if needed
    }).catch(err => {
        console.error('Failed to copy: ', err);
    });
};

const TransactionDetail = ({ item, onClose, checkLabel, t }) => {
    return (
        <div className='dpsCt p-0 position-relative mt-0'>
            <header className='w-100 d-flex justify-content-between p-3'>
                <p className='text-lg font-weight-bold text-light m-0'>{checkLabel(item.transaction_type_label)}</p>
                <button onClick={onClose} className=''>
                    <svg xmlns="http://www.w3.org/2000/svg" width="19.125"
                        height="19.125" viewBox="0 0 19.125 19.125">
                        <path id="Path_67111" data-name="Path 67111"
                            d="M19.565,1.56a1.913,1.913,0,0,0-2.7,0l-6.3,6.3-6.3-6.3a1.912,1.912,0,1,0-2.7,2.7l6.3,6.3-6.3,6.3a1.912,1.912,0,1,0,2.7,2.7l6.3-6.3,6.3,6.3a1.912,1.912,0,1,0,2.7-2.7l-6.3-6.3,6.3-6.3A1.913,1.913,0,0,0,19.565,1.56Z"
                            transform="translate(-1 -1)" fill="#fff"></path>
                    </svg>
                </button>
            </header>
            <div className={'modal-body mt-4 text-center position-relative flex-1 flex-shrink-1 p-3'}>
                <div>
                    <div className={'border-none rounded-[6px] overflow-hidden mb-30 '}>
                        <div className={'pb-3 p-3 w-100'}>
                            <div
                                className={'pt-0 d-flex justify-content-between pb-3 border-b text-capitalize text-sm leading-[20px]'}>
                                <p className={'text-light mb-0'}>Thời gian</p>
                                <p className={'mb-0'}>{formatDate(item.created_at)}</p>
                            </div>
                            <div
                                className={'pt-0 d-flex justify-content-between pt-2 pb-3 border-b text-capitalize text-sm leading-[20px]'}>
                                <p className={'text-light mb-0'}>Giá trị</p>
                                <p className={`${item.value < 0 ? 'text-down' : 'text-up'} mb-0`}>{item.value > 0 ? '+' : ''}{formatNumberDecimal(item.value)}</p>
                            </div>
                            <div
                                className={'pt-0 d-flex justify-content-between pt-2 pb-3  border-b text-capitalize text-sm leading-[20px]'}>
                                <p className={'text-light mb-0'}>Txid/Mô tả</p>
                                {item.payment_type !== null && item.payment_type === 'transfer' ? (
                                    <span>{item.note || ''}</span>)
                                    : (
                                        <div className="d-flex align-items-center">
                                            <a className='mb-0' style={{ color: '#0e9dff', textDecoration: 'underline' }} target={'_blank'} href={`https://bscscan.com/tx/${item.tx}`}>{formatTxHash(item.tx)}</a>
                                            <button 
                                                onClick={() => copyToClipboard(item.tx)}
                                                className="btn btn-link p-0 ml-2"
                                                style={{ minWidth: 'auto', color: '#0e9dff' }}
                                                title="Copy full transaction hash"
                                            >
                                                <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
                                                    <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"/>
                                                    <path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z"/>
                                                </svg>
                                            </button>
                                        </div>
                                    )}
                            </div>
                            <div
                                className={'pt-0 d-flex justify-content-between pt-2 pb-3  border-b text-capitalize text-sm leading-[20px]'}>
                                <p className={'text-light mb-0'}>Ghi chú</p>
                                <p className={'mb-0'}>{item.description || ''}</p>
                            </div>
                            <div
                                className={'pt-0 d-flex justify-content-between pt-2 pb-3 text-capitalize text-sm leading-[20px]'}>
                                <p className={'text-light mb-0'}>Tình trạng</p>
                                <p className={'mb-0'}>{t(`${toUpper(item.transaction_status)}`)}</p>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
};
function mapStateToProps(state) {
    return {
        memberReducer: state.memberReducer,
        appReducer: state.appReducer
    };
}
const withSnackbar = (Component) => (props) => {
    const { enqueueSnackbar } = useSnackbar();
    return <Component {...props} enqueueSnackbar={enqueueSnackbar} />;
};
export default connect(mapStateToProps, {

})(withRouter(withTranslation()(withSnackbar(TransactionDetail))));